var Settings = {
  init: function() {
    Settings.controlTypes.init();

    $('#save-settings-btn')
      .off ( 'click' )
      .on  ( 'click', function ( evt ) {
        Settings.save();
      });
  },

  save : function() {
    var settings = [];

    $('.setting[data-changed="1"]').each ( function ( index, elem ) {
      settings.push({
        id: $(elem).attr ( 'data-setting-id' ),
        value: $(elem).attr ( 'data-value' ),
      });
    });

    var sendData = {
      settings: settings,
    };

    $.ajax({
      url: '/ajax/AJAX-settings/save',
      data: sendData,
      type: 'post',
      dataType: 'json',
      success: function ( returnedData ) {
        console.log(returnedData);
      },
    });
  },

  ///////////////////////
  // - CONTROL TYPES - //
  ///////////////////////
  
  controlTypes : {
    init : function() {
      Settings.controlTypes.timediffFuture.init();
    },
    // - TIMEDIFF-FUTURE
    timediffFuture : {
      init : function() {
        $('.setting.timediff-future').find('input, select')
          .off ( 'change' )
          .on  ( 'change', function ( evt ) {
            Settings.controlTypes.timediffFuture.timediffChanged ( evt );
          });
      },

      timediffChanged : function ( evt ) {
        var value = '+' +
                    $(evt.target).closest ( '.timediff-future' ).find ( '.number' ).val() + ' ' +
                    $(evt.target).closest ( '.timediff-future' ).find ( '.unit' ).val();

        $(evt.target).closest ( '.setting' )
          .attr ( 'data-changed', 1 )
          .attr ( 'data-value', value );
      },
    },
  },
};